import React from 'react';

import * as S from './PlusButton.styles';

const PlusButton: React.FC<React.HTMLAttributes<HTMLDivElement>> = props => {
  return <S.PlusButton onClick={props.onClick}>+</S.PlusButton>;
};

export default PlusButton;
